import Vue from 'vue';
import VueRouter from 'vue-router';
import routeConfig from './routeConfig.js';
import RouterUtil from "./RouterUtil";

//配置信息
const contextPath = '/container-cargo'; // 自动时自动生成，无需手工配置
//---------------------------------------------------

Vue.use(VueRouter);

const router = new VueRouter({
  base: contextPath || '',
  mode: 'history',
  routes: routeConfig.routes
});

// let firstFlag = true;  // 标记每次刷新后重置为true 根据本标记决定是否重新取动态路由

router.beforeEach((to, from, next) => {
  Promise.resolve().then(() => {
    const $vue = router.app;
    // 判断如果已登录，且企业信息正常，则直接放行
    // console.log('路由守卫')
    $vue.$store.dispatch('checkLang').then(() => RouterUtil.hasLoginAndCompanyApproved($vue, to)).catch(() => {
      // console.log('校验是否游客 + 公开地址');
      // 判断如果是访客 + 访客白名单
      return RouterUtil.checkVisitorUrl($vue, to);
    }).catch(() => {
      // 判断如果是用户 + 没企业
      return RouterUtil.checkUserAndNoCompany($vue, to);
    }).catch(() => {
      // 判断如果是用户 + 企业未通过审核
      return RouterUtil.checkUserAndCompanyChecking($vue, to);
    }).catch(() => {
      // console.log('尝试自动登录校验是否游客 + 公开地址');
      return RouterUtil.autoLogin(router.app, to)
    }).then(target => {
      // console.log('完成跳转', target);
      if (target) {  // 重新让路由查一次 避免进404
        next({ path: target, replace: true, query: to.query });
      } else {
        next();
      }
    });
  });
});

export default router;
